import { render, staticRenderFns } from "./reportDetail.static.vue?vue&type=template&id=3adf3328"
import script from "./reportDetail.static.vue?vue&type=script&lang=js"
export * from "./reportDetail.static.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports